import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing shadow-sm" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = {
  key: 0,
  class: "upload-zone mb-4"
}
const _hoisted_5 = {
  key: 1,
  class: "file-info-section mb-4"
}
const _hoisted_6 = { class: "alert alert-info d-flex align-items-center" }
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "mb-1 fw-semibold" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "card border mb-4" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "row g-3" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "form-check mb-2" }
const _hoisted_17 = { class: "form-check mb-2" }
const _hoisted_18 = { class: "form-check mb-2" }
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = { class: "d-flex justify-content-end gap-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 2,
  class: "import-progress-section mb-4"
}
const _hoisted_23 = { class: "card border" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = {
  class: "progress mb-3",
  style: {"height":"25px"}
}
const _hoisted_26 = ["aria-valuenow"]
const _hoisted_27 = { class: "list-unstyled mb-0" }
const _hoisted_28 = {
  key: 3,
  class: "import-result-success"
}
const _hoisted_29 = { class: "alert alert-success" }
const _hoisted_30 = { class: "d-flex align-items-start" }
const _hoisted_31 = { class: "flex-grow-1" }
const _hoisted_32 = { class: "card border mb-3" }
const _hoisted_33 = { class: "card-body" }
const _hoisted_34 = { class: "row g-3" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = { class: "mb-2" }
const _hoisted_38 = { class: "mb-2" }
const _hoisted_39 = { class: "mb-2" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "mb-2" }
const _hoisted_42 = { class: "mb-2 text-success" }
const _hoisted_43 = { class: "mb-2 text-warning" }
const _hoisted_44 = {
  key: 0,
  class: "alert alert-warning mb-3"
}
const _hoisted_45 = { class: "mt-2" }
const _hoisted_46 = { class: "d-flex gap-3" }
const _hoisted_47 = {
  key: 4,
  class: "import-result-error"
}
const _hoisted_48 = { class: "alert alert-danger" }
const _hoisted_49 = { class: "d-flex align-items-start" }
const _hoisted_50 = { class: "flex-grow-1" }
const _hoisted_51 = { class: "card border border-danger mb-3" }
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "mb-2" }
const _hoisted_54 = { class: "mb-0" }
const _hoisted_55 = { class: "d-flex gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[58] || (_cache[58] = _createElementVNode("div", {
        class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
        style: {"background-color":"#0a59a4"}
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-white fw-bold mb-1" }, "Import de Manifeste Navire"),
          _createElementVNode("small", { class: "text-white opacity-75" }, "Téléversez un fichier XML/EDI de manifeste armateur")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.uploadedFile && !_ctx.importing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["dropzone-area border-2 border-dashed rounded p-5 text-center", { 'border-primary bg-light': _ctx.isDragging, 'border-secondary': !_ctx.isDragging }]),
                onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isDragging = true), ["prevent"])),
                onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isDragging = false), ["prevent"])),
                onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args))),
                style: {"cursor":"pointer","min-height":"250px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}
              }, [
                _cache[18] || (_cache[18] = _createStaticVNode("<i class=\"flaticon-upload fs-1 text-primary mb-3\" data-v-44ad952b></i><h5 class=\"fw-semibold mb-2\" data-v-44ad952b>Glissez votre fichier ici</h5><p class=\"text-muted mb-3\" data-v-44ad952b>ou cliquez pour parcourir</p><div class=\"text-muted small\" data-v-44ad952b><p class=\"mb-1\" data-v-44ad952b>Formats acceptés : <strong data-v-44ad952b>.xml, .edi</strong></p><p class=\"mb-0\" data-v-44ad952b>Taille maximale : <strong data-v-44ad952b>10 MB</strong></p></div>", 4)),
                _createElementVNode("input", {
                  ref: "fileInput",
                  type: "file",
                  accept: ".xml,.edi",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args))),
                  class: "d-none"
                }, null, 544)
              ], 34)
            ]))
          : _createCommentVNode("", true),
        (_ctx.uploadedFile && !_ctx.importing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-file-1 fs-3 me-3" }, null, -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.uploadedFile.name), 1),
                  _createElementVNode("small", _hoisted_9, " Taille : " + _toDisplayString(_ctx.formatFileSize(_ctx.uploadedFile.size)) + " | Type : " + _toDisplayString(_ctx.uploadedFile.type || 'application/xml'), 1)
                ]),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-outline-danger",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelUpload && _ctx.cancelUpload(...args))),
                  type: "button"
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "flaticon-delete" }, null, -1),
                  _createTextVNode(" Annuler ", -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-header bg-light" }, [
                  _createElementVNode("h6", { class: "mb-0 fw-semibold" }, "Options d'import")
                ], -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Système source (optionnel)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.importOptions.sourceSystem) = $event)),
                        class: "form-control shadow-sm",
                        placeholder: "ex: ANTASER, Code armateur..."
                      }, null, 512), [
                        [_vModelText, _ctx.importOptions.sourceSystem]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Compagnie maritime (optionnel)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.importOptions.carrierCode) = $event)),
                        class: "form-control shadow-sm",
                        placeholder: "ex: APLFW, AMSC..."
                      }, null, 512), [
                        [_vModelText, _ctx.importOptions.carrierCode]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.importOptions.autoCreateVoyage) = $event)),
                          id: "autoCreateVoyage"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.importOptions.autoCreateVoyage]
                        ]),
                        _cache[23] || (_cache[23] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "autoCreateVoyage"
                        }, " Créer automatiquement le voyage si inexistant ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.importOptions.autoCreatePortCalls) = $event)),
                          id: "autoCreatePortCalls"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.importOptions.autoCreatePortCalls]
                        ]),
                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "autoCreatePortCalls"
                        }, " Créer automatiquement les escales ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.importOptions.autoMatchBls) = $event)),
                          id: "autoMatchBls"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.importOptions.autoMatchBls]
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "autoMatchBls"
                        }, " Tenter le rapprochement automatique avec les BL BESC ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.importOptions.blockDuplicates) = $event)),
                          id: "blockDuplicates"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.importOptions.blockDuplicates]
                        ]),
                        _cache[26] || (_cache[26] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "blockDuplicates"
                        }, " Bloquer si fichier déjà importé (via checksum) ", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-secondary px-4",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.cancelUpload && _ctx.cancelUpload(...args))),
                  type: "button"
                }, " Annuler "),
                _createElementVNode("button", {
                  class: "btn btn-primary px-5 py-2 text-white",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.startImport && _ctx.startImport(...args))),
                  type: "button",
                  disabled: _ctx.loading
                }, [
                  _cache[28] || (_cache[28] = _createElementVNode("i", { class: "flaticon-upload me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Import en cours...' : 'Importer le manifeste'), 1)
                ], 8, _hoisted_21)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.importing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "fw-semibold mb-3" }, "Import en cours...", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", {
                      class: "progress-bar progress-bar-striped progress-bar-animated",
                      role: "progressbar",
                      style: _normalizeStyle({ width: _ctx.importProgress + '%' }),
                      "aria-valuenow": _ctx.importProgress,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, _toDisplayString(_ctx.importProgress) + "% ", 13, _hoisted_26)
                  ]),
                  _createElementVNode("ul", _hoisted_27, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["mb-2", _ctx.getStepClass('parsing')])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.getStepIcon('parsing'))
                      }, null, 2),
                      _cache[29] || (_cache[29] = _createTextVNode(" Parsing XML ", -1))
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["mb-2", _ctx.getStepClass('validation')])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.getStepIcon('validation'))
                      }, null, 2),
                      _cache[30] || (_cache[30] = _createTextVNode(" Validation structure ", -1))
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["mb-2", _ctx.getStepClass('voyage')])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.getStepIcon('voyage'))
                      }, null, 2),
                      _cache[31] || (_cache[31] = _createTextVNode(" Création voyage ", -1))
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["mb-2", _ctx.getStepClass('bls')])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.getStepIcon('bls'))
                      }, null, 2),
                      _cache[32] || (_cache[32] = _createTextVNode(" Import BL ", -1))
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["mb-2", _ctx.getStepClass('containers')])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.getStepIcon('containers'))
                      }, null, 2),
                      _cache[33] || (_cache[33] = _createTextVNode(" Import conteneurs ", -1))
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.getStepClass('cargo'))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.getStepIcon('cargo'))
                      }, null, 2),
                      _cache[34] || (_cache[34] = _createTextVNode(" Import marchandises ", -1))
                    ], 2)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.importResult && _ctx.importResult.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[52] || (_cache[52] = _createElementVNode("i", { class: "flaticon-check-mark fs-2 me-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[51] || (_cache[51] = _createElementVNode("h5", { class: "fw-bold mb-3" }, " Import réussi !", -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _cache[43] || (_cache[43] = _createElementVNode("h6", { class: "fw-semibold mb-3" }, "Statistiques", -1)),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("p", _hoisted_36, [
                              _cache[36] || (_cache[36] = _createElementVNode("strong", null, "ID Manifeste :", -1)),
                              _createElementVNode("code", null, _toDisplayString(_ctx.importResult.data.manifestId), 1)
                            ]),
                            _createElementVNode("p", _hoisted_37, [
                              _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Voyage créé :", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.importResult.data.voyageCode) + " (Navire: " + _toDisplayString(_ctx.importResult.data.shipName) + ") ", 1)
                            ]),
                            _createElementVNode("p", _hoisted_38, [
                              _cache[38] || (_cache[38] = _createElementVNode("strong", null, "BL importés :", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.importResult.data.blsCount), 1)
                            ]),
                            _createElementVNode("p", _hoisted_39, [
                              _cache[39] || (_cache[39] = _createElementVNode("strong", null, "Conteneurs :", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.importResult.data.containersCount), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("p", _hoisted_41, [
                              _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Lignes de marchandises :", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.importResult.data.cargoItemsCount), 1)
                            ]),
                            _createElementVNode("p", _hoisted_42, [
                              _cache[41] || (_cache[41] = _createElementVNode("strong", null, "BL rapprochés automatiquement :", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.importResult.data.matchedBlsCount), 1)
                            ]),
                            _createElementVNode("p", _hoisted_43, [
                              _cache[42] || (_cache[42] = _createElementVNode("strong", null, "BL non rapprochés :", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.importResult.data.unmatchedBlsCount), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.importResult.data.unmatchedBlsCount > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _cache[45] || (_cache[45] = _createElementVNode("i", { class: "flaticon-warning me-2" }, null, -1)),
                          _cache[46] || (_cache[46] = _createElementVNode("strong", { class: "text text-black" }, "Attention :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.importResult.data.unmatchedBlsCount) + " BL n'ont pas pu être rapprochés automatiquement. ", 1),
                          _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                          _cache[48] || (_cache[48] = _createElementVNode("small", { class: "text text-black" }, "Vous devrez effectuer un rapprochement manuel.", -1)),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-warning",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToManualMatching(_ctx.importResult.data.manifestId))),
                              type: "button"
                            }, [...(_cache[44] || (_cache[44] = [
                              _createElementVNode("i", { class: "flaticon-link me-2" }, null, -1),
                              _createTextVNode(" Rapprocher manuellement ", -1)
                            ]))])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.viewManifestDetails(_ctx.importResult.data.manifestId))),
                        type: "button"
                      }, [...(_cache[49] || (_cache[49] = [
                        _createElementVNode("i", { class: "flaticon-eye me-2" }, null, -1),
                        _createTextVNode(" Voir les détails du manifeste ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "btn btn-success",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.resetUpload && _ctx.resetUpload(...args))),
                        type: "button"
                      }, [...(_cache[50] || (_cache[50] = [
                        _createElementVNode("i", { class: "flaticon-plus me-2" }, null, -1),
                        _createTextVNode(" Importer un autre manifeste ", -1)
                      ]))])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.importResult && !_ctx.importResult.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _cache[57] || (_cache[57] = _createElementVNode("i", { class: "flaticon-close fs-2 me-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_50, [
                    _cache[56] || (_cache[56] = _createElementVNode("h5", { class: "fw-bold mb-3" }, "Erreur d'import", -1)),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("p", _hoisted_53, [
                          _cache[53] || (_cache[53] = _createElementVNode("strong", null, "Code erreur :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.importResult.error.code), 1)
                        ]),
                        _createElementVNode("p", _hoisted_54, [
                          _cache[54] || (_cache[54] = _createElementVNode("strong", null, "Message :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.importResult.error.message), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.resetUpload && _ctx.resetUpload(...args))),
                        type: "button"
                      }, [...(_cache[55] || (_cache[55] = [
                        _createElementVNode("i", { class: "flaticon-refresh me-2" }, null, -1),
                        _createTextVNode(" Réessayer ", -1)
                      ]))])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}